<template>
  <div
    v-if="loading || !hasData"
    class="empty"
  >
    <img
      src="../../../public/img/folder.svg"
      alt="No information"
    >
    <h4 class="empty-title">
      {{ loading ? loadingText: noDataText }}
    </h4>
    <span class="empty-sub-title"  v-if="noDataMessageLine2 !== undefined && noDataMessageLine2 !== null" >
      {{loading? '': noDataMessageLine2}}
    </span>
  </div>
</template>

<script>

export default {
  name: 'NajNoData',
  props: {
    hasData: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    loadingMessage: {
      type: String,
      required: false,
      default: null,
    },
    noDataMessage: {
      type: String,
      required: false,
      default: null,
      },
    noDataMessageLine2: {
       type: String,
       required: false,
       default: null,
      },
  },
  computed: {
    noDataText() {
      return this.noDataMessage || this.local.common.noData;
    },
    loadingText() {
      return this.loadingMessage || this.local.common.loading;
    },
  },
};
</script>

<style lang="scss" scoped>
.empty {
  align-items: center;
  border: 0;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  margin-bottom: 24px;
  margin-top: 33px;
  padding: 16px;
  text-align: center;
}
.empty-title {
  font-weight: 700;
  font-size: 32px;
  line-height: 43px;
  margin: 32px 0 15px;
}
.empty-sub-title{
    font-size:25px;
}

</style>
